import axios from 'axios';
import BASE_URL from '../config/baseUrl';

const API_URL = `${BASE_URL}/superadmin`;

// Get auth token
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

// Get all admins
export const getAllAdmins = async () => {
  const response = await axios.get(`${API_URL}/admins`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Create new admin
export const createAdmin = async (adminData) => {
  const response = await axios.post(`${API_URL}/admins`, adminData, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Update admin
export const updateAdmin = async (id, adminData) => {
  const response = await axios.put(`${API_URL}/admins/${id}`, adminData, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Delete admin
export const deleteAdmin = async (id) => {
  const response = await axios.delete(`${API_URL}/admins/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Reset admin password
export const resetAdminPassword = async (id, newPassword) => {
  const response = await axios.post(
    `${API_URL}/admins/${id}/reset-password`,
    { newPassword },
    { headers: getAuthHeader() }
  );
  return response.data;
};

// Get admin statistics
export const getAdminStats = async () => {
  const response = await axios.get(`${API_URL}/stats`, {
    headers: getAuthHeader()
  });
  return response.data;
};
